import { render, staticRenderFns } from "./Layout6.vue?vue&type=template&id=2c9a1e76&scoped=true&"
import script from "./Layout6.vue?vue&type=script&lang=js&"
export * from "./Layout6.vue?vue&type=script&lang=js&"
import style0 from "./Layout6.vue?vue&type=style&index=0&id=2c9a1e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9a1e76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
